import React, { FC, useContext } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { AlertContext } from "../../../Context/Alerts/Alert.Provider";
import { Button } from "@material-ui/core";
import { AlertActions } from "../../../Context/Alerts/Alert.Actions";

const Alert: FC = () => {
  const alertContext = useContext(AlertContext);

  return (
    <Dialog
      open={alertContext.isOpen}
      keepMounted
      onClose={() => console.log()}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle id="alert-dialog-slide-title">
        {alertContext.title}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-slide-description">
          {alertContext.message}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() =>
            alertContext.dispatch &&
            alertContext.dispatch(AlertActions.setClosed())
          }
        >
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default Alert;
